import { render, staticRenderFns } from "./DelDialog.vue?vue&type=template&id=8bd564e6&scoped=true"
import script from "./DelDialog.vue?vue&type=script&lang=js"
export * from "./DelDialog.vue?vue&type=script&lang=js"
import style0 from "./DelDialog.vue?vue&type=style&index=0&id=8bd564e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd564e6",
  null
  
)

export default component.exports